import { FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import Modal from '@components/Modal/Modal';

import { INotificationModalProps, TSupplementType } from './NotificationModal.interface';

import './style.scss';

const NotificationModal: FC<INotificationModalProps> = ({
  open,
  onClose,
  onExited,
  onConfirm,
  dataInModal,
  isMedicationMode = false,
}) => {
  const { t } = useTranslation();

  const handleConfirm = useCallback((): void => {
    if (dataInModal) {
      onConfirm(dataInModal);
    }
    onClose();
  }, [onClose, onConfirm, dataInModal]);

  const notificationDescriptionText = useMemo(() => {
    const key = isMedicationMode ? 'medicationInquiry' : 'dietarySupplementInquiry';
    return dataInModal?.type === TSupplementType.INQUIRY
      ? t(`${key}.removeInquiryNotification`)
      : t(`${key}.removeInquiryItemNotification`);
  }, [dataInModal?.type, isMedicationMode]);

  return (
    <Modal
      onClose={onClose}
      onExited={onExited}
      open={open}
      className="inquiry-notification-modal"
      leftActionTitle={t('common.cancel')}
      onLeftAction={onClose}
      rightActionTitle={t('dietarySupplementInquiry.removeInquiry')}
      onRightAction={handleConfirm}
    >
      <Box
        component="img"
        className="inquiry-notification-modal__image"
        src="/images/img-shredder.svg"
      />
      {notificationDescriptionText && (
        <p className="inquiry-notification-modal__caption">{notificationDescriptionText}</p>
      )}
      <h5 className="inquiry-notification-modal__sub-caption">
        {t('dietarySupplementInquiry.thisCannotBeUndone')}
      </h5>
    </Modal>
  );
};

export default NotificationModal;
